import { render, staticRenderFns } from "./project-documents-folder-management.vue?vue&type=template&id=8dc07a98&"
import script from "./project-documents-folder-management.vue?vue&type=script&lang=js&"
export * from "./project-documents-folder-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports